/** The Radar mark — a sweep in a ring, echoing the learner-facing RadarHero's
    sweep but rendered as a standalone product mark for Project Radar AI. */
export function RadarMark({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9.2" stroke="currentColor" strokeWidth="1.6" opacity="0.9" />
      <circle cx="12" cy="12" r="5.2" stroke="currentColor" strokeWidth="1.2" opacity="0.45" />
      <path d="M12 12 L12 3.4 A8.6 8.6 0 0 1 18.6 6.4 Z" fill="currentColor" opacity="0.8" />
      <circle cx="12" cy="12" r="1.6" fill="currentColor" />
    </svg>
  );
}
